import React from 'react'
import { useTranslation } from 'react-i18next'
import { MagneticButton } from '../shared/MagneticButton'
import { SectionShell } from '../shared/SectionShell'
import meImage from '../../assets/me.png'

export default function OutroSection() {
    const { t } = useTranslation()

    return (
        <SectionShell id="outro" className="outro-section">
            <div className="outro-rings" aria-hidden="true">
                {[1, 2, 3, 4].map((n) => (
                    <div key={n} className="outro-ring" style={{ width: `${n * 160}px`, height: `${n * 160}px` }} />
                ))}
            </div>

            <div className="outro-content">
                <div className="outro-avatar-wrap">
                    <img
                        src={meImage}
                        alt={t('outro.avatarAlt')}
                        className="outro-avatar"
                    />
                </div>

                <h2 className="outro-title">
                    <span className="outro-title-line">{t('outro.line1')}</span>
                    <span className="outro-title-line outro-title-line--italic">{t('outro.line2')}</span>
                </h2>

                <p className="outro-sub">{t('outro.sub')}</p>

                <MagneticButton className="outro-cta-wrap" strength={0.35}>
                    <a
                        href="mailto:admin@itsmyhub.me?subject=Let%27s%20build%20something"
                        className="outro-cta"
                        data-magnetic
                    >
                        {t('outro.cta')}
                        <svg viewBox="0 0 20 20" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <line x1="4" y1="10" x2="16" y2="10" />
                            <polyline points="10 4 16 10 10 16" />
                        </svg>
                    </a>
                </MagneticButton>
            </div>

            <footer className="outro-footer">
                <div className="outro-footer-divider" />
                <div className="outro-footer-cols">
                    <div className="outro-footer-col">
                        <span className="outro-footer-company">{t('footer.company')}</span>
                        <span className="outro-footer-item">{t('footer.ceoLabel')} {t('footer.ceo')}</span>
                    </div>
                    <div className="outro-footer-col">
                        <span className="outro-footer-item">
                            <span className="outro-footer-dim">{t('footer.addressLabel')}</span>
                            {' '}{t('footer.address')}
                        </span>
                    </div>
                    <div className="outro-footer-col">
                        <span className="outro-footer-item">
                            <span className="outro-footer-dim">{t('footer.bizLabel')}</span>
                            {' '}{t('footer.biz')}
                        </span>
                    </div>
                </div>
            </footer>
        </SectionShell>
    )
}
